import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const EllisIcon = () => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path d="M15.4995 9.75069L15.4995 11.2107L20.7596 11.2107L20.7596 9.75069L15.4995 9.75069Z" />
    <path
      d="M15.4995 9.75069L15.4995 11.2107L20.7596 11.2107L20.7596 9.75069L15.4995 9.75069Z"
      stroke="inherit"
    />
    <path d="M15.3413 11.8941L14.7082 13.2097L19.4479 15.4908L20.0811 14.1752L15.3413 11.8941Z" />
    <path
      d="M15.3413 11.8941L14.7082 13.2097L19.4479 15.4908L20.0811 14.1752L15.3413 11.8941Z"
      stroke="inherit"
    />
    <path d="M14.2711 13.7415L13.1301 14.6523L16.4117 18.7632L17.5528 17.8523L14.2711 13.7415Z" />
    <path
      d="M14.2711 13.7415L13.1301 14.6523L16.4117 18.7632L17.5528 17.8523L14.2711 13.7415Z"
      stroke="inherit"
    />
    <path d="M12.5053 14.9443L11.0821 15.2703L12.2564 20.3976L13.6796 20.0717L12.5053 14.9443Z" />
    <path
      d="M12.5053 14.9443L11.0821 15.2703L12.2564 20.3976L13.6796 20.0717L12.5053 14.9443Z"
      stroke="inherit"
    />
    <path d="M6.16517 11.8944L6.79831 13.21L2.05856 15.491L1.42542 14.1755L6.16517 11.8944Z" />
    <path
      d="M6.16517 11.8944L6.79831 13.21L2.05856 15.491L1.42542 14.1755L6.16517 11.8944Z"
      stroke="inherit"
    />
    <path d="M7.23541 13.7415L8.37643 14.6523L5.09477 18.7632L3.95375 17.8523L7.23541 13.7415Z" />
    <path
      d="M7.23541 13.7415L8.37643 14.6523L5.09477 18.7632L3.95375 17.8523L7.23541 13.7415Z"
      stroke="inherit"
    />
    <path d="M9.00113 14.9446L10.4243 15.2705L9.24997 20.3978L7.82682 20.0719L9.00113 14.9446Z" />
    <path
      d="M9.00113 14.9446L10.4243 15.2705L9.24997 20.3978L7.82682 20.0719L9.00113 14.9446Z"
      stroke="inherit"
    />
    <path d="M15.3412 9.06191L14.7081 7.74634L19.4478 5.46525L20.081 6.78082L15.3412 9.06191Z" />
    <path
      d="M15.3412 9.06191L14.7081 7.74634L19.4478 5.46525L20.081 6.78082L15.3412 9.06191Z"
      stroke="inherit"
    />
    <path d="M14.271 7.21458L13.13 6.30371L16.4116 2.19284L17.5527 3.1037L14.271 7.21458Z" />
    <path
      d="M14.271 7.21458L13.13 6.30371L16.4116 2.19284L17.5527 3.1037L14.271 7.21458Z"
      stroke="inherit"
    />
    <path d="M12.5053 6.01174L11.0821 5.68579L12.2564 0.558457L13.6796 0.884402L12.5053 6.01174Z" />
    <path
      d="M12.5053 6.01174L11.0821 5.68579L12.2564 0.558457L13.6796 0.884402L12.5053 6.01174Z"
      stroke="inherit"
    />
    <path d="M6.16504 9.06191L6.79819 7.74634L2.05844 5.46525L1.4253 6.78082L6.16504 9.06191Z" />
    <path
      d="M6.16504 9.06191L6.79819 7.74634L2.05844 5.46525L1.4253 6.78082L6.16504 9.06191Z"
      stroke="inherit"
    />
    <path d="M7.23529 7.21458L8.37631 6.30371L5.09465 2.19284L3.95363 3.1037L7.23529 7.21458Z" />
    <path
      d="M7.23529 7.21458L8.37631 6.30371L5.09465 2.19284L3.95363 3.1037L7.23529 7.21458Z"
      stroke="inherit"
    />
    <path d="M9.00101 6.01174L10.4242 5.68579L9.24985 0.558457L7.8267 0.884402L9.00101 6.01174Z" />
    <path
      d="M9.00101 6.01174L10.4242 5.68579L9.24985 0.558457L7.8267 0.884402L9.00101 6.01174Z"
      stroke="inherit"
    />
    <path
      d="M20.7596 9.74805H0.759613V11.208H20.7596V9.74805Z"
    />
    <path
      d="M20.7596 9.74805H0.759613V11.208H20.7596V9.74805Z"
      stroke="inherit"
    />
  </SvgIcon>
);

export default EllisIcon;
